import { createRouter, createWebHistory } from "vue-router";
import IndexPage from "./pages/IndexPage.vue"
import ProjectsPage from './pages/ProjectsPage.vue'

const ProjectPage = () => 
    import('./pages/ProjectPage.vue');

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { name: 'index', path: '/', component: IndexPage },
        { name: 'projects', path: '/reggenius/projects', component: ProjectsPage },
        { name: 'project', path: '/reggenius/project', component: ProjectPage },
        // Fallback route
        { path: '/:pathMatch(.*)', redirect: '/' }, // Matches any path
    ]
});

export default router;